/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PagamentoCreateDTO
 */
export interface PagamentoCreateDTO {
    /**
     * 
     * @type {boolean}
     * @memberof PagamentoCreateDTO
     */
    acconto?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PagamentoCreateDTO
     */
    data?: Date;
    /**
     * 
     * @type {number}
     * @memberof PagamentoCreateDTO
     */
    importo?: number;
    /**
     * 
     * @type {string}
     * @memberof PagamentoCreateDTO
     */
    note?: string | null;
}

/**
 * Check if a given object implements the PagamentoCreateDTO interface.
 */
export function instanceOfPagamentoCreateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PagamentoCreateDTOFromJSON(json: any): PagamentoCreateDTO {
    return PagamentoCreateDTOFromJSONTyped(json, false);
}

export function PagamentoCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagamentoCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'acconto': !exists(json, 'acconto') ? undefined : json['acconto'],
        'data': !exists(json, 'data') ? undefined : (new Date(json['data'])),
        'importo': !exists(json, 'importo') ? undefined : json['importo'],
        'note': !exists(json, 'note') ? undefined : json['note'],
    };
}

export function PagamentoCreateDTOToJSON(value?: PagamentoCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'acconto': value.acconto,
        'data': value.data === undefined ? undefined : (value.data.toISOString()),
        'importo': value.importo,
        'note': value.note,
    };
}

